<div
  class="modal fade"
  id="contactUsModal"
  tabindex="-1"
  aria-labelledby="contactUsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header border-0 pb-0">
        <div>
          <h4 class="modal-title fw-bold mb-0" id="contactUsModalLabel">
            <i class="bi bi-envelope-heart me-2 text-primary"></i>Contact Us
          </h4>
          <p class="text-muted small mb-0 mt-1">We'd love to hear from you. Fill in the form below and we'll get back to you.</p>
        </div>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="resetModal()"
        ></button>
      </div>

      <div class="modal-body pt-3">

        <!-- Success State -->
        @if (submitted()) {
          <div class="text-center py-5">
            <div class="mb-3">
              <i class="bi bi-check-circle-fill text-success" style="font-size: 3rem;"></i>
            </div>
            <h5 class="fw-bold text-dark">Message Sent!</h5>
            <p class="text-muted">
              Thank you for reaching out. Our team will review your enquiry and get back to you as soon as possible.
            </p>
            <p class="text-muted small mb-0">
              <i class="bi bi-envelope me-1"></i>You can also email us directly at
              <a href="mailto:admin@medvisit.co.za" class="text-primary">admin&#64;medvisit.co.za</a>
            </p>
          </div>
        }

        <!-- Error Banner -->
        @if (errorMessage()) {
          <div class="alert alert-danger d-flex align-items-start gap-2 mb-3" role="alert">
            <i class="bi bi-exclamation-octagon-fill flex-shrink-0 mt-1"></i>
            <div class="small">{{ errorMessage() }}</div>
          </div>
        }

        <!-- Form -->
        @if (!submitted()) {
          <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
            <div class="row g-3">

              <!-- First Name -->
              <div class="col-md-6">
                <label for="cu-firstName" class="form-label fw-semibold">First Name <span class="text-danger">*</span></label>
                <input
                  id="cu-firstName"
                  type="text"
                  class="form-control"
                  formControlName="firstName"
                  placeholder="e.g. John"
                  autocomplete="given-name"
                />
                @if (form.controls['firstName'].touched && form.controls['firstName'].invalid) {
                  <div class="text-danger small mt-1">First name is required.</div>
                }
              </div>

              <!-- Last Name -->
              <div class="col-md-6">
                <label for="cu-lastName" class="form-label fw-semibold">Last Name <span class="text-danger">*</span></label>
                <input
                  id="cu-lastName"
                  type="text"
                  class="form-control"
                  formControlName="lastName"
                  placeholder="e.g. Smith"
                  autocomplete="family-name"
                />
                @if (form.controls['lastName'].touched && form.controls['lastName'].invalid) {
                  <div class="text-danger small mt-1">Last name is required.</div>
                }
              </div>

              <!-- Email -->
              <div class="col-md-6">
                <label for="cu-email" class="form-label fw-semibold">Email Address <span class="text-danger">*</span></label>
                <input
                  id="cu-email"
                  type="email"
                  class="form-control"
                  formControlName="email"
                  placeholder="e.g. john@example.com"
                  autocomplete="email"
                />
                @if (form.controls['email'].touched && form.controls['email'].errors?.['required']) {
                  <div class="text-danger small mt-1">Email is required.</div>
                }
                @if (form.controls['email'].touched && form.controls['email'].errors?.['email']) {
                  <div class="text-danger small mt-1">Enter a valid email address.</div>
                }
              </div>

              <!-- Cell Number -->
              <div class="col-md-6">
                <label for="cu-cellNumber" class="form-label fw-semibold">Cell Number <span class="text-danger">*</span></label>
                <input
                  id="cu-cellNumber"
                  type="tel"
                  class="form-control"
                  formControlName="cellNumber"
                  placeholder="+27 71 234 5678"
                  autocomplete="tel"
                />
                @if (form.controls['cellNumber'].touched && form.controls['cellNumber'].invalid) {
                  <div class="text-danger small mt-1">Enter a valid phone number.</div>
                }
              </div>

              <!-- Purpose of Enquiry -->
              <div class="col-12">
                <label for="cu-purpose" class="form-label fw-semibold">Purpose of Enquiry <span class="text-danger">*</span></label>
                <select
                  id="cu-purpose"
                  class="form-select"
                  formControlName="purposeOfEnquiry"
                >
                  <option value="" disabled>Select a purpose...</option>
                  @for (option of purposeOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
                @if (form.controls['purposeOfEnquiry'].touched && form.controls['purposeOfEnquiry'].invalid) {
                  <div class="text-danger small mt-1">Please select a purpose.</div>
                }
              </div>

              <!-- Comments -->
              <div class="col-12">
                <label for="cu-comments" class="form-label fw-semibold">Comments <span class="text-danger">*</span></label>
                <textarea
                  id="cu-comments"
                  class="form-control"
                  formControlName="comments"
                  rows="4"
                  placeholder="Please describe your enquiry in detail..."
                ></textarea>
                @if (form.controls['comments'].touched && form.controls['comments'].errors?.['required']) {
                  <div class="text-danger small mt-1">Comments are required.</div>
                }
                @if (form.controls['comments'].touched && form.controls['comments'].errors?.['minlength']) {
                  <div class="text-danger small mt-1">Please provide at least 10 characters.</div>
                }
              </div>

            </div>
          </form>
        }

      </div>

      <!-- Footer -->
      @if (!submitted()) {
        <div class="modal-footer border-0 pt-0">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-bs-dismiss="modal"
            (click)="resetModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary px-4"
            [disabled]="isSubmitting()"
            (click)="submit()"
          >
            @if (isSubmitting()) {
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Sending...
            } @else {
              <i class="bi bi-send me-2"></i>Send Message
            }
          </button>
        </div>
      } @else {
        <div class="modal-footer border-0 pt-0 justify-content-center">
          <button
            type="button"
            class="btn btn-outline-primary"
            data-bs-dismiss="modal"
            (click)="resetModal()"
          >
            Close
          </button>
        </div>
      }

    </div>
  </div>
</div>
